import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import counterpart from 'counterpart';

import LinkInlineButton from 'Components/Button/LinkInlineButton';
import DragHandleIcon from 'Components/icons/DragHandleIcon';
import EyeIcon from 'Components/icons/EyeIcon';
import InformationBubble from 'Components/information-bubble';
import ChevronDownIcon from 'Components/icons/ChevronDownIcon';

import './ColumnWidget.scss';

const ColumnWidget = ({
  actions,
  children,
  desc,
  extraClass,
  identifier,
  isSelected,
  isHidden,
  name,
  isReadOnly,
  required,
  toggleVisibility,
  animate,
  id,
  showVisibility,
  dropdown,
  isExpanded,
  reportName,
  
}) => {
  const  acquirerCode = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode;
  const wrapperClass = classnames('column-widget '+acquirerCode, {
    [extraClass]: extraClass,
    'read-only': isReadOnly,
    unselected: !isSelected,
    animate,
  });
  
  const translation = {
    visibleColumn: counterpart('globalTranslate.common.visibleColumn'),
  };

  const actionList = (reportName === 'MRE' && actions && actions.length) ? actions.map((action, index) => {
    return (
      <LinkInlineButton
        id={`${id}_${name}_btn_${action.icon().props.className}`}
        action={() => { action.callback(identifier); }}
        extraClass="column-widget__action-button"
        key={identifier.toString() + index} // eslint-disable-line react/no-array-index-key
        disabled={isReadOnly}
      >
        {action.icon()}
      </LinkInlineButton>
    );
  }) :
  (actions && actions.length)
    ? actions.map((action, index) => {
      return (
        <LinkInlineButton
          id={`${id}_${name}_btn_${action.icon().props.className}`}
          action={() => { action.callback(identifier); }}
          extraClass="column-widget__action-button"
          key={identifier.toString() + index} // eslint-disable-line react/no-array-index-key
        >
          {action.icon()}
        </LinkInlineButton>
      );
    })
    : null;
   //const acquirerCode=JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode;

   // add chevron up and down code change
  const dropDownList = (dropdown && dropdown.length) 
   ? dropdown.map((action, index) => {
      return (
        <LinkInlineButton
          id={`${id}_${name}_btn_${index}`}
          action={() => { action.callback(identifier); }}
          extraClass="column-widget__action-button"
          key={identifier.toString()+'_dropDown_'+ index} // eslint-disable-line react/no-array-index-key
        >
          <span className='column-widget__chevron-icon'><ChevronDownIcon width='10' height='9' transform={isExpanded ? 'rotate(0)' : 'rotate(-90)'}/></span>
        </LinkInlineButton>
      );
    }) : null;

  return (
    <div className={wrapperClass}>
      {
        isSelected && <DragHandleIcon />
      }
      <div className={reportName !== 'MRE' ? "column-widget__identity" : "column-widget__identity column-widget__identity--mre "}>
        {dropDownList && dropDownList.length > 0 && <div className="column-widget__drop-action">
          {dropDownList}
        </div>}
        <div id={`${id}_${name}_lbl`}>
          <span className={acquirerCode=="HPY"?'column-widget__nameHPY':'column-widget__name'}><strong>{name}</strong></span>
          <span className="column-widget__children">{children}</span>
        </div>
       
      </div>
      <div className="column-widget__actions">
        {
          showVisibility && isSelected &&
          typeof toggleVisibility === 'function' &&
          <LinkInlineButton
            id={`${id}_${name}_btn_eye`}
            action={toggleVisibilityHandler}
            extraClass={visibilityClass}
          >
            <EyeIcon slash={isHidden} title={translation.visibleColumn} />
          </LinkInlineButton>
        }
        {actionList}
      </div>
      {isExpanded && children}
    </div>
  );
};

ColumnWidget.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      callback: PropTypes.func,
      icon: PropTypes.func,
    }),
  ),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  desc: PropTypes.string,
  extraClass: PropTypes.string,
  identifier: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  isSelected: PropTypes.bool,
  isHidden: PropTypes.bool,
  name: PropTypes.string.isRequired,
  isReadOnly: PropTypes.bool,
  required: PropTypes.bool,
  toggleVisibility: PropTypes.func,
  animate: PropTypes.bool,
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  showVisibility: PropTypes.bool,
  translation: PropTypes.object,
  isExpanded: PropTypes.bool,
  reportName: PropTypes.string,
  
};

ColumnWidget.defaultProps = {
  actions: [],
  children: null,
  desc: '',
  extraClass: '',
  isSelected: false,
  isHidden: false,
  isReadOnly: false,
  toggleVisibility: null,
  required: false,
  animate: false,
  id: '',
  showVisibility: true,
  dropdown: [],
  isExpanded: false,
  reportName: ''
  
};

export default ColumnWidget;
